import React from 'react';
import { BudgetSummaryStatus } from 'src/types/budget-summary-status.enum';
import styles from './budgetProgressBar.module.scss';
import Selectors from 'src/utils/selectors';
import { Tooltip } from '@americanexpress/dls-react';
import { getOverBudgetPercent, getProgressPercent, getTrackerStatus } from 'src/utils/budget.utils';
import FormatService from 'src/services/format.service';

interface ProgressBarProps {
    spentAmount: number;
    budgetAmount: number;
}

/** TODO: this is the new BudgetProgressBar component created as part of BANK-9047. Once the
 * feature is fully implemented, and the feature flag is removed, this component will replace the
 * old BudgetProgressBar component, which can then be removed. Once that happens, remove this comment as well.
 **/
export default function BudgetProgressBar({ spentAmount, budgetAmount }: ProgressBarProps): JSX.Element {
    const status: BudgetSummaryStatus = getTrackerStatus(spentAmount, budgetAmount);
    const progressPercent: number = getProgressPercent(spentAmount, budgetAmount);
    const overPercent: number = getOverBudgetPercent(spentAmount, budgetAmount);

    const statusClassName: string =
        status === BudgetSummaryStatus.OVER
            ? styles.bad
            : status === BudgetSummaryStatus.AT_RISK
            ? styles.warning
            : styles.good;

    const coloredProgressBarStyle =
        progressPercent === 0 || progressPercent === 100
            ? styles.coloredProgressBarWithoutBorder
            : styles.coloredProgressBarWithBorder;

    return (
        <div className={styles.progressBar} data-cy={Selectors.SpendSmart.PROGRESS_BAR}>
            <div
                className={`${coloredProgressBarStyle} ${statusClassName}`}
                style={{ width: `${progressPercent}%` }}
                data-cy={Selectors.SpendSmart.COLORED_PROGRESS_BAR}
            >
                {overPercent > 0 && (
                    <Tooltip
                        id="budgetAmountProgressBarTooltip"
                        aria-labelledby="budget-amount"
                        className={styles.breakerTooltip}
                        data-cy={Selectors.SpendSmart.PROGRESS_BAR_TOOLTIP}
                        style={{ marginRight: `${overPercent}%` }}
                        triggerElement={
                            <button className={styles.breakerButton}>
                                <div />
                            </button>
                        }
                    >
                        {FormatService.format(budgetAmount)}
                    </Tooltip>
                )}
            </div>
        </div>
    );
}
